function isEmptyValue(value) {
    return value == null || value === "" ||
        (typeof value === "string" && value.trim().toLowerCase() === "dbnull");
}
function joinValues(values, element, semicolon) {
    if (element instanceof HTMLTextAreaElement)
        return values.map(String).join("\n");
    return values.map(String).join(semicolon ? ", " : "; ");
}
function clearElement(element) {
    element.value = "";
    element.setAttribute("data-value", "");
    element.setAttribute("data-title", "");
}
function selectSingle(context, item, index) {
    const display = context.displayText(item);
    context.element.value = display;
    context.element.setAttribute("data-title", display);
    context.element.setAttribute("data-value", item.key);
    if (item.url)
        window.location.href = item.url;
    context.emitComboChange({ item, index });
    context.element.dispatchEvent(new Event("change", { bubbles: true }));
    context.refocusCaretToEnd();
}

export { clearElement, isEmptyValue, joinValues, selectSingle };
